import { atom } from 'jotai';

const RouteStateAtoms = {
  route: atom<{
    org?: string;
    agent?: string;
  }>({}),
};

RouteStateAtoms.route.debugLabel = 'RouteStateAtoms.Route';

export default RouteStateAtoms;
